<template>
  <div class="news-wrapper main flex-between">
            <div class="left-section">
                <div class="subtitle composite-subtitle">
                    <h2 class="">综合新闻</h2>
                </div>
                <ul class="news-lists">
                    <li class="" v-for="(li, index) in lists" :key="index" @click="toPage(li.id)">
                        <!-- 无图 -->
                        <div class="type" v-if="li.showType === 3">
                            <div class="article notImg">
                                <h3 class="f16 wes">{{li.title}}</h3>
                                <p class="f12 wes-3">{{li.introduction}}</p>
                                <div class="summary flex-align-between">
                                    <span class="date">{{li.updateTime}}</span>
                                    <span class="look-num">{{li.views}}</span>
                                </div>
                            </div>  
                        </div>
                        <!-- 1图 -->
                        <div class="type flex-align-between" v-else-if="li.showType === 1"> 
                            <img :src="li.cover" alt="">
                            <div class="article">
                                <h3 class="f16 wes">{{li.title}}</h3>
                                <p class="f12 wes-3">{{li.introduction}}</p>
                                <div class="summary flex-align-between f12">
                                    <span class="date">{{li.updateTime}}</span>
                                    <span class="look-num">{{li.views}}</span>
                                </div>
                            </div>
                        </div>
                        <!-- 3图 -->
                        <div class="type" v-else-if="li.showType === 2">
                            <h3 class="f16 wes">{{li.title}}</h3>
                            <div class="img-box">
                                <img :src="li.cover" alt="">
                                <img :src="li.cover" alt="">
                                <img :src="li.cover" alt="">
                            </div>
                            <div class="summary flex-align-between f12">
                                <span class="date">{{li.updateTime}}</span>
                                <span class="look-num">{{li.views}}</span>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="loading">
                    <button class="load-more" @click="getNewsList()" :class="[loadClass?'load-more':'load-more-none']">{{loadText}}</button>                  
                </div>
            </div>
            <focusBar></focusBar>
        </div>
</template>

<script>
export default {
    data() {
        return {
            currentPage:1,
            loadText:'加载更多',
            loadClass:true,
            lists:[{
                type:0,
                imgURL:'',
                title:'首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学...',
                introduction:'教学、教研、培训，避免资源“溢出，避免资源“溢出，避免资源“溢出整合设计，避免资源“溢出”效应，“减负增效”“双优云桥”针对疫情实际做适应性调整，并提前启动全部子项目',
                updateTime:'2020.06.03',
                views:'1572',
            },{
                type:1,
                imgURL:'',
                title:'首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学...',
                introduction:'教学、教研、培训整合设计，避免培训整合设计，避免资源“溢出培训整合设计，避免资源“溢出培训整合设计，避免资源“溢出培训整合设计，避免资源“溢出资源“溢出”效应，“减负增效”“双优云桥”针对疫情实际做适应性调整，并提前启动全部子项目',
                updateTime:'2020.06.03',
                views:'1572',
            },{
                type:2,
                imgURL:'',
                title:'首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学...',
                introduction:'教学、教研、培训整合设计，避免资源“溢出”效应，“减负增效”“双优云桥”针对疫情实际做适应性调整，并提前启动全部子项目',
                updateTime:'2020.06.03',
                views:'1572',
            }],
        }
    },
    methods: {
        async getNewsList(){
            let params = {
                clazz:2,
                isAsc:'desc',
                pageNum: this.currentPage++,
                pageSize: 7
            }            
            let resData = await Api.News.GetNewsList(params)
            console.log(resData)
            // this.lists = resData.rows;
            // this.schoolList = resData.rows
            params.pageNum = this.currentPage;
            let res = await Api.News.GetNewsList(params)
            if(res.rows.length < 1) {
                this.loadText = '加载已完成'
                this.loadClass = false;
            }
            
            this.lists = this.lists.concat(resData.rows);

         },
         toPage(id) {
             Common.goPage(`/news/composite/detail/${id}`,this)
         }
    },
    mounted(){
        this.getNewsList();
    }
}
</script>

<style lang="less" scoped>
    @import "../less/news_common.less";
    @import "../less/news_headlines.less";
</style>